import React from "react";
import ShoppingCartImageSvgDark from "./ShoppingCartImageSvgDark";

const ShoppingCartDark = () => <ShoppingCartImageSvgDark />;
export default ShoppingCartDark;
